import React from "react";
import { Text } from "../../Text";
import { Button } from "../../Button";

export const InlineLoadingError = () => (
  <div>
    <br />
    <br />
    <Text isHeading isCenter text="Ooops!" />
    <br />
    <Text isSubheading isCenter text="We couldn't load the page..." />
    <br />
    <br />
    <div style={{ textAlign: "center" }}>
      <Button
        primary
        text="Try again"
        onClick={(e) => {
          e.preventDefault();
          window.location.reload();
        }}
      />
    </div>
    <br />
    <br />
    <br />
  </div>
);
